<ng-diagram-node-resize-adornment>
  <div
    class="group-node normal-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'attachment'"
    [node]="node()"
  >
    <ng-diagram-port id="port-right" side="right" style="top: 30px" type="source" />

    <div class="group-node__header">
      <mat-icon class="ddc-content-icon">{{ icon() }}</mat-icon>
      <span class="group-node__title">{{ title() }}</span>
    </div>
    <div class="group-node__content" data-configurable="true">
      <div class="content-row">
        <mat-icon class="content-icon">image</mat-icon>
        <span class="content-word">{{ attachmentLabel }}</span>
      </div>
    </div>
  </div>
</ng-diagram-node-resize-adornment>
